export default __webpack_public_path__ + "bf21d4c3ba6312a10757450b23b32450.svg";